/**
 * Utility functions for text processing and formatting
 */

/**
 * Detects if a text string contains markdown formatting
 * @param {string} text - The text to check for markdown patterns
 * @returns {boolean} - True if markdown patterns are detected, false otherwise
 */
export const isMarkdown = text => {
  if (!text || typeof text !== "string") return false;

  // Check for common markdown patterns
  const markdownPatterns = [
    /^#{1,6}\s/m, // Headers: # ## ###
    /\*\*[^*]+\*\*/g, // Bold: **text**
    /__[^_]+__/g, // Bold: __text__
    /\*[^*]+\*/g, // Italic: *text*
    /_[^_]+_/g, // Italic: _text_
    /\[.+\]\(.+\)/g, // Links: [text](url)
    /^[-*+]\s/m, // Unordered lists: - item, * item, + item
    /^\d+\.\s/m, // Ordered lists: 1. item
    /```[\s\S]*?```/g, // Code blocks: ```code```
    /`[^`]+`/g, // Inline code: `code`
    /^>\s/m, // Blockquotes: > quote
    /!\[.*?\]\(.*?\)/g, // Images: ![alt](url)
    /^---$/m, // Horizontal rules: ---
    /^\*\*\*$/m, // Horizontal rules: ***
    /~~[^~]+~~/g, // Strikethrough: ~~text~~
  ];

  // Check if any pattern matches
  return markdownPatterns.some(pattern => pattern.test(text));
};

/**
 * Truncates text to a specified length and adds ellipsis
 * @param {string} text - The text to truncate
 * @param {number} maxLength - Maximum length of the text
 * @returns {string} - Truncated text with ellipsis if needed
 */
export const truncateText = (text, maxLength) => {
  if (!text || text.length <= maxLength) return text;
  return `${text.slice(0, maxLength)}...`;
};
